import { ArrowTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/ArrowTone';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface BoxColors {
  fill: string;
  stroke: string;
  dash?: string;
}

export const useDiagramColors = () => {
  const { palette, customBorderRadius } = useCustomTheme();

  const box: Record<BoxTone, BoxColors> = {
    [BoxTone.REQUEST]: { fill: palette.secondary.main, stroke: 'none' },
    [BoxTone.DONE]: { fill: palette.grey[200], stroke: palette.grey[400] },
    [BoxTone.NEUTRAL]: { fill: palette.background.paper, stroke: palette.grey[400] },
    [BoxTone.YES]: { fill: palette.background.paper, stroke: palette.success.main },
    [BoxTone.NO]: { fill: palette.background.paper, stroke: palette.grey[400] },
    [BoxTone.MAYBE]: { fill: palette.background.paper, stroke: palette.warning.main },
    [BoxTone.ERROR]: { fill: palette.background.paper, stroke: palette.error.main },
    [BoxTone.ANY]: { fill: palette.background.paper, stroke: palette.info.main },
    [BoxTone.GHOST]: { fill: 'none', stroke: palette.grey[300], dash: '3 3' },
    [BoxTone.HIGHLIGHT]: { fill: palette.success.light, stroke: palette.primary.main },
  };
  const text: Record<TextTone, string> = {
    [TextTone.DEFAULT]: palette.text.primary,
    [TextTone.MUTED]: palette.text.secondary,
    [TextTone.YES]: palette.success.main,
    [TextTone.NO]: palette.text.secondary,
    [TextTone.MAYBE]: palette.warning.main,
    [TextTone.ERROR]: palette.error.main,
    [TextTone.ANY]: palette.info.main,
    [TextTone.GHOST]: palette.grey[400],
    [TextTone.INVERSE]: palette.secondary.contrastText,
  };
  const arrow: Record<ArrowTone, string> = {
    [ArrowTone.LINE]: palette.grey[500],
    [ArrowTone.ACCENT]: palette.info.main,
    [ArrowTone.MUTED]: palette.grey[400],
  };

  return {
    // Capped so small boxes never turn into pills with round-cornered themes.
    radius: Math.min(customBorderRadius.paper, 10),
    box,
    text,
    arrow,
    stop: palette.success.main,
    bar: palette.grey[300],
    barWin: palette.success.main,
  };
};

export type DiagramColors = ReturnType<typeof useDiagramColors>;
